import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL_OLD,
  PLAYER_ONLINE,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'useronline' })
export default class Suggest extends VuexModule {
  userOnline: any = [];

  @Mutation
  mutateUserOnline(userOnline) {
    this.userOnline = userOnline;
  }

  @Action
  FetchPlayerOnline(params) {
    return Vue.axios({
      url: BASE_URL_OLD + PLAYER_ONLINE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const player = data.data;
          return player;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
